'use client';
import { Icon } from '@iconify/react';
import { Menu } from '@mantine/core';
import style from './language-option.module.scss';
import clsx from 'clsx';
import { useBreakpoints } from '@/hooks/useBreakpoints';
import { useEffect, useState } from 'react';
import { setLanguageData } from '@/lib/features/language/languageSlice';
import { useDispatch, useSelector } from 'react-redux';
import { languageData as languageInfo } from '@/lib/utils/languageData';
import { getDictionary } from '@/app/dictionaries';

function detectLocale() {
    const cookie = document.cookie;
    // const lang = navigator.language || 'he';
    const lang = 'he';
    const match = cookie.match(/(?:^|;\s*)locale=([^;]+)/);

    if (match) {
        return match[1];
    }
    return lang.slice(0, 2);
}
const LanguageOption = () => {
    const { smDevice } = useBreakpoints();
    const [locale, setLocale] = useState('he');
    const dispatch = useDispatch();
    const { languageData } = useSelector((state) => state.language);

    useEffect(() => {
        const detected = detectLocale();
        setLocale(detected);
        loadTranslations(detected);
    }, [locale]);

    const loadTranslations = async (lang) => {
        const data = await getDictionary(lang, true);
        dispatch(setLanguageData(data));
    };

    const handleLanguageChange = (lang) => {
        setLocale(lang);
        document.cookie = `locale=${lang}; path=/; max-age=31536000`;
    };

    const localeObj = languageInfo.find((item) => item.locale === locale);

    return (
        <>
            <Menu width={150} arrowOffset={50} arrowSize={10} withArrow position="bottom" className={style.language_option}>
                <Menu.Target>
                    <button className="header_btn language_btn scale-effect" type="button">
                        <div className={clsx(style.avatar, "btn_avatar")}>
                            {/* <Image src="/images/flags/usa.svg" alt="USA" width={40} height={40} /> */}
                            <Icon icon={`${localeObj?.flag}-1x1`} fontSize="2.5rem" className={clsx('btn_dropdown_icon')} />
                        </div>
                        <div className="btn_content">
                            <span className={clsx('btn_text', style.btn_text)}>
                                {smDevice && locale.toUpperCase()}
                                <Icon icon="mingcute:down-fill" fontSize="1.125rem" className={clsx('btn_dropdown_icon')} />
                            </span>
                        </div>
                    </button>
                </Menu.Target>
                <Menu.Dropdown className={style.menu_dropdown}>
                    {languageInfo?.map((item, index) => (
                        <Menu.Item
                            leftSection={<Icon icon={`${item?.flag}-4x3`} fontSize="1.5rem" />}
                            onClick={() => handleLanguageChange(item.locale)}
                            key={index}
                            className={clsx(style.menu_item, languageData?.language === item.locale && style.menu_active)}
                        >
                            <span>{item.language}</span>
                        </Menu.Item>
                    ))}
                </Menu.Dropdown>
            </Menu>
        </>
    );
};

export default LanguageOption;
